import React, { useState, useEffect } from 'react';
import './navbar.css';
import { useLocation } from "react-router-dom";
import axios from "axios";


const Monitor_conferma_inizio_stage = () => {

    const search = useLocation().search;
    const attore = new URLSearchParams(search).get('attore');
    const id = new URLSearchParams(search).get('id');
    const indice = new URLSearchParams(search).get('indice');
    const valore = new URLSearchParams(search).get('valore');

    const [variab_aggiorna, SET_variab_aggiorna] = useState('');

    useEffect(() => {
        console.log(id)
        console.log(indice)
        console.log(valore)

        axios.patch('/progetti/stage_confermato_dalla_ditta/' + id + '/' + valore)
            .then((res) => {
                console.log(res.data)
                SET_variab_aggiorna(JSON.stringify(res.data))
            }).catch((error) => {
                console.log(error)
            });
    }, []);




    return (
        <div>
            <h1>Grazie per la risposta</h1>
            <p> Cordiali Saluti</p>
            <p>{id} - {attore} - {indice} - {valore} - {variab_aggiorna}</p>

        </div>
    );
}
export default Monitor_conferma_inizio_stage;